import { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { Layout } from '../../components/front'
import { getProductCategories, getStaticDate } from '../../lib'
import { withSession, createCaptcha } from '../../utils/server'
import { num_a2e, num_p2e } from '../../utils'

export let getServerSideProps = withSession(async ({ req }) => {
    //don't let logged in users come to this page
    if (req.session.get('user')) {
        return {
            redirect: {
                destination: '/',
                permanent: false
            }
        }
    }

    const captcha = createCaptcha()

    req.session.set('captcha', captcha.key)
    await req.session.save()

    const data = await getStaticDate()
    const hier = await getProductCategories()

    return { props: { productCategories: hier, captcha_img: captcha.imageUrl, footer: data['about_footer'].content } }
})

const schema = yup.object().shape({
    first_name: yup.string().required('نام خود را وارد کنید'),
    last_name: yup.string().required('نام خانوادگی خود را وارد کنید'),
    mobile: yup
        .string()
        .transform(function (value) {
            return num_a2e(num_p2e(value))
        })
        .matches(/^09\d{9}$/, 'شماره موبایل را به فرم 09xxxxxxxxx وارد کنید')
        .required('شماره موبایل خود را وارد کنید'),
    email: yup.string().email('فرمت ایمیل صحیح نیست'),
    captcha: yup.string().required('عبارت امنیتی را وارد کنید'),
    password: yup.string().required('رمز عبور را وارد کنید'),
    password_repeat: yup
        .string()
        .test('passwords-match', 'تکرار رمز عبور با خود آن برابر نیست', function (value) {
            return this.parent.password === value
        })
        .required('تکرار رمز عبور را وارد کنید')
})

export default function Register({ productCategories, captcha_img, footer }) {
    const router = useRouter()
    const [message, setMessage] = useState('')
    const [captchaImage, setCaptchaImage] = useState('')
    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        resolver: yupResolver(schema)
    })
    useEffect(() => {
        setCaptchaImage(captcha_img)
    }, [captcha_img])
    async function onSubmit(data) {
        try {
            const response = await fetch('/api/auth/register', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            })
            let responseObject = await response.json()
            if (response.status === 200) {
                router.push('/auth/activate?receiver=' + data.mobile)
            } else if (response.status === 400) {
                if (responseObject.newCaptchaImage) {
                    reset({ ...data, captcha: '' })
                    setCaptchaImage(responseObject.newCaptchaImage)
                }
                setMessage(responseObject.message)
            }
        } catch (error) {
            console.error('An unexpected error happened occurred:', error)
        }
    }

    return (
        <Layout menu={productCategories} footer={{ about: footer }}>
            <section className="bg-gray-200 py-12">
                <div className="container mx-auto">
                    <div className="flex justify-center px-6">
                        <div className="w-full xl:w-3/4 lg:w-11/12 flex">
                            <div className="w-full lg:w-7/12 bg-white p-5 rounded-lg lg:rounded-l-none">
                                <h3 className="pt-4 text-2xl text-center mb-6 text-purple-400">در سایت ثبت نام کنید</h3>
                                <form
                                    onSubmit={handleSubmit(onSubmit)}
                                    className="lg:px-8 pt-6 pb-8 mb-4 bg-white rounded"
                                >
                                    <div className="mb-4 md:flex md:justify-between">
                                        <div className="mb-4 md:ml-2 md:mb-0 w-full md:w-1/2">
                                            <label
                                                className="block mb-2 text-sm font-bold text-gray-700"
                                                htmlFor="first_name"
                                            >
                                                نام *
                                            </label>
                                            <input
                                                className="w-full px-3 py-2 mb-3 text-sm leading-tight rounded-md border border-gray-200 shadow-sm focus:outline-none focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                                name="first_name"
                                                type="text"
                                                placeholder="نام"
                                                {...register('first_name')}
                                            />
                                            {errors?.first_name?.message}
                                        </div>
                                        <div className="md:ml-2 w-full md:w-1/2">
                                            <label
                                                className="block mb-2 text-sm font-bold text-gray-700"
                                                htmlFor="last_name"
                                            >
                                                نام خانوادگی *
                                            </label>
                                            <input
                                                className="w-full px-3 py-2 mb-3 text-sm leading-tight rounded-md border border-gray-200 shadow-sm focus:outline-none focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                                name="last_name"
                                                type="text"
                                                placeholder="نام خانوادگی"
                                                {...register('last_name')}
                                            />
                                            {errors?.last_name?.message}
                                        </div>
                                    </div>
                                    <div className="mb-4 md:flex md:justify-between">
                                        <div className="mb-4 md:ml-2 md:mb-0 w-full md:w-1/2">
                                            <label
                                                className="block mb-2 text-sm font-bold text-gray-700"
                                                htmlFor="mobile"
                                            >
                                                شماره موبایل *
                                            </label>
                                            <input
                                                className="w-full px-3 py-2 mb-3 text-sm leading-tight rounded-md border border-gray-200 shadow-sm focus:outline-none focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                                name="mobile"
                                                type="text"
                                                placeholder="موبایل"
                                                {...register('mobile')}
                                            />
                                            {errors?.mobile?.message}
                                        </div>
                                        <div className="mb-4 md:ml-2 md:mb-0 w-full md:w-1/2">
                                            <label
                                                className="block mb-2 text-sm font-bold text-gray-700"
                                                htmlFor="email"
                                            >
                                                ایمیل
                                            </label>
                                            <input
                                                className="w-full px-3 py-2 mb-3 text-sm leading-tight rounded-md border border-gray-200 shadow-sm focus:outline-none focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                                name="email"
                                                type="text"
                                                placeholder="ایمیل"
                                                {...register('email')}
                                            />
                                            {errors?.email?.message}
                                        </div>
                                    </div>
                                    <div className="mb-4 md:flex md:justify-between">
                                        <div className="mb-4 md:ml-2 md:mb-0 w-full md:w-1/2">
                                            <label
                                                className="block mb-2 text-sm font-bold text-gray-700"
                                                htmlFor="password"
                                            >
                                                گذرواژه *
                                            </label>
                                            <input
                                                className="w-full px-3 py-2 mb-3 text-sm leading-tight rounded-md border border-gray-200 shadow-sm focus:outline-none focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                                name="password"
                                                autoComplete="new-password"
                                                type="password"
                                                placeholder="گذرواژه"
                                                {...register('password')}
                                            />
                                            {errors?.password?.message}
                                        </div>
                                        <div className="md:ml-2 w-full md:w-1/2">
                                            <label
                                                className="block mb-2 text-sm font-bold text-gray-700"
                                                htmlFor="password_repeat"
                                            >
                                                تکرار گذرواژه *
                                            </label>
                                            <input
                                                className="w-full px-3 py-2 mb-3 text-sm leading-tight rounded-md border border-gray-200 shadow-sm focus:outline-none focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                                name="password_repeat"
                                                autoComplete="new-password"
                                                type="password"
                                                placeholder="تکرار گذرواژه"
                                                {...register('password_repeat')}
                                            />
                                            {errors?.password_repeat?.message}
                                        </div>
                                    </div>
                                    <div className="mb-4 md:pl-2 md:mb-0 w-full sm:w-1/2">
                                        <label className="block mb-2 text-sm font-bold text-gray-700" htmlFor="tel">
                                            عبارت امنیتی
                                        </label>
                                        <div className="flex justify-center">
                                            <img src={captchaImage} className="w-full rounded-t-md" />
                                        </div>
                                        <input
                                            className="w-full px-3 py-2 mb-3 text-sm leading-tight rounded-b-md border border-gray-200 shadow-sm focus:outline-none focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                            name="captcha"
                                            autoComplete="off"
                                            dir="auto"
                                            placeholder="عبارت امنیتی"
                                            {...register('captcha')}
                                        />
                                        {errors?.captcha?.message}
                                    </div>

                                    <p className="text-red-500">{message}</p>
                                    <div className="mb-6 text-center">
                                        <button
                                            className="w-full px-4 py-2 font-bold text-white bg-purple-400 rounded-lg hover:bg-pink-400 focus:outline-none focus:shadow-outline"
                                            type="submit"
                                        >
                                            ثبت نام
                                        </button>
                                    </div>
                                    <hr className="mb-6 border-t" />
                                    <div className="text-center">
                                        <Link href="/auth/signin">
                                            <a className="inline-block text-sm text-blue-500 align-baseline hover:text-blue-800">
                                                قبلا ثبت نام کرده اید؟ وارد شوید
                                            </a>
                                        </Link>
                                    </div>
                                </form>
                            </div>

                            <div
                                className="w-full h-auto bg-gray-400 hidden lg:block lg:w-5/12 bg-cover rounded-l-lg pt-20"
                                style={{
                                    backgroundColor: 'white'
                                }}
                            >
                                <img src="/img/register.gif" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}
